/*
 * File: resourceManifest.slice.js
 * Project: our-wave-stories-app
 *
 * Created by Brendan Michaelsen on May 17, 2025 at 3:04 PM
 * Copyright © 2025 Our Wave, Inc. All rights reserved.
 *
 * Last Modified: May 21, 2025 at 1:24 PM
 * Modified By: Brendan Michaelsen
 */

/**
 * Imports
 */

// Modules
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

// Services
import { getResourceManifest } from '../../../services/resource';


/**
 * Constants
 */

export const initialState = {
	status: 'idle',
	error: null,
	resources: [],
	escapeUrls: {}
};


/**
 * Functions
 */

export const fetchResourceManifest = createAsyncThunk('resourceManifest/fetchResourceManifest', async () => {

	// Fetch objects
	const { data } = await getResourceManifest();

	// Return objects
	return data;
});


/**
 * Slices
 */

export const resourceManifestSlice = createSlice({
	name: 'resourceManifest',
	initialState,
	reducers: {
		updateResourceManifest: (state, action) => {

			// Set state
			state.resources = action.payload;
			state.status = 'final';
		},
		clearResourceManifest: (state) => {

			// Clear state
			state.resources = [];
		},
	},
	extraReducers: {
		[fetchResourceManifest.pending]: (state) => {
			state.status = 'loading';
		},
		[fetchResourceManifest.fulfilled]: (state, action) => {
			state.status = 'final';
			state.resources = action.payload.resources;
			state.escapeUrls = action.payload.escapeUrls;
		},
		[fetchResourceManifest.rejected]: (state, action) => {
			state.status = 'failed';
			state.error = action.error.message;
		},
	},
});


/**
 * Exports
 */

export const { updateResourceManifest, clearResourceManifest } = resourceManifestSlice.actions;

export default resourceManifestSlice.reducer;
